exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slider-wrapper .owl-carousel .owl-item img{display:inline-block;width:auto!important}.product-category-block .slider-wrapper .owl-carousel .owl-item img{width:35px!important;height:35px!important}.recommend-items{padding:8px 4px}.mt-3{margin-top:25px}@media only screen and (min-width:992px){.home-product-categories-wrapper .nav-button.button-next{display:none!important}}", ""]);

// exports
